import React from 'react';
import './DesignedForAdventureBlock.scss';

import HorizontalScrollImages from './HorizontalScrollImages/HorizontalScrollImages';
import { RichText } from '@sitecore-jss/sitecore-jss-react';

export default function DesignedForAdventureBlock({ fields }) {
  return (
    <div style={{ overflow: 'hidden' }}>
      <div className="container car-model-design-block">
        <div className={'title'} data-aos="fade-up">
          <h2>
            <RichText field={fields.titleText} />
          </h2>
          <p>{fields.description.value}</p>
        </div>
      </div>
      <HorizontalScrollImages items={fields?.images} />
    </div>
  );
}
